import React from 'react';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import Section from './Section';

const EditKum = () => (
  <>
    <Navbar />
    <Header />
    <Section />
  </>
);

export default EditKum;
